export default __webpack_public_path__ + "static/media/pokemon.5511e54e.png";